import { css, useTheme } from '@emotion/react';

const useStyle = () => {
  const theme = useTheme();
  const { primary } = theme.palette;

  const container = css`
    --gap: 15px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    gap: var(--gap);
    flex-flow: wrap;

    @media (max-width: 1110px) {
      flex-wrap: wrap;
      gap: 35px;
      margin-top: 10px;
    }

    @media (max-width: 725px) {
      gap: 25px;
    }

    @media (max-width: 650px) {
      gap: 15px;
    }

    & > div {
      display: flex;
      flex-direction: column;
      gap: var(--gap);
    }

    & > div:first-of-type {
      flex: 1;

      @media (max-width: 1150px) {
        flex: 0;
      }
    }

    & h5,
    & a {
      color: ${primary.main};
      font-size: 16px;
      line-height: 21px;
      font-weight: 300;
      margin-bottom: 0;
    }

    & h5 a {
      font-weight: 700;
    }

    & a:hover {
      text-shadow: 0 0 0.5px ${primary.main}, 0 0 0.5px ${primary.main};
    }

    @media (max-width: 1150px) {
      & > div {
        width: 165px;
      }
    }

    & .items {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(200px, 2fr));
      gap: var(--gap);

      & > div {
        display: flex;
        flex-direction: column;
        gap: var(--gap);
      }
    }
  `;

  return {
    container,
  };
};

export default useStyle;
